import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import Tarifs from "./pages/Tarifs";
import GiftCards from "./pages/GiftCards";
import Reservation from "./pages/Reservation";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Checkout from "./pages/Checkout";
import Admin from "./pages/Admin";
import Legal from "./pages/Legal";
import { Toaster } from "./components/ui/toaster";

// Anti-theft protection hook — disables right-click, drag, devtools shortcuts,
// and blurs the page when tab loses focus (partial screenshot mitigation on mobile).
function useAntiTheftProtection() {
  const location = useLocation();
  useEffect(() => {
    // Do NOT restrict admin pages (owner needs full browser features)
    if (location.pathname.startsWith("/admin")) return;

    const preventDefault = (e) => e.preventDefault();
    const onKeyDown = (e) => {
      // Block: F12, Ctrl+S, Ctrl+U, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+Shift+C, Ctrl+P, PrintScreen
      if (
        e.keyCode === 123 ||
        e.keyCode === 44 || // PrintScreen
        (e.ctrlKey && ["s", "u", "p"].includes((e.key || "").toLowerCase())) ||
        (e.ctrlKey && e.shiftKey && ["i", "j", "c", "p"].includes((e.key || "").toLowerCase())) ||
        (e.metaKey && ["s", "u", "p"].includes((e.key || "").toLowerCase())) ||
        (e.metaKey && e.altKey && ["i", "j", "c"].includes((e.key || "").toLowerCase())) ||
        (e.metaKey && e.shiftKey && ["3", "4", "5"].includes(e.key)) // macOS screenshots
      ) {
        e.preventDefault();
        try { navigator.clipboard && navigator.clipboard.writeText(""); } catch (err) { if (process.env.NODE_ENV !== 'production') { /* eslint-disable-next-line no-console */ console.debug('[anti-theft] clipboard clear blocked', err); } }
        return false;
      }
    };

    // --- Anti-screenshot (partial): blur content when window loses focus ---
    const blurOnHide = () => {
      if (document.hidden) {
        document.body.style.filter = "blur(20px)";
      } else {
        document.body.style.filter = "";
      }
    };
    const blurOnBlur = () => { document.body.style.filter = "blur(20px)"; };
    const unblurOnFocus = () => { document.body.style.filter = ""; };

    document.addEventListener("contextmenu", preventDefault);
    document.addEventListener("dragstart", preventDefault);
    document.addEventListener("selectstart", (e) => {
      const t = e.target;
      if (t && (t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.isContentEditable)) return;
      e.preventDefault();
    });
    document.addEventListener("keydown", onKeyDown);
    document.addEventListener("visibilitychange", blurOnHide);
    window.addEventListener("blur", blurOnBlur);
    window.addEventListener("focus", unblurOnFocus);

    // --- Detect DevTools open (devtools-detect technique) ---
    // If the console is open, window.outerWidth - window.innerWidth > 200 (on desktop)
    const checkDevTools = () => {
      const threshold = 160;
      const widthDiff = window.outerWidth - window.innerWidth;
      const heightDiff = window.outerHeight - window.innerHeight;
      if (widthDiff > threshold || heightDiff > threshold) {
        document.body.style.filter = "blur(30px)";
      }
    };
    const devToolsInterval = setInterval(checkDevTools, 1000);

    return () => {
      document.removeEventListener("contextmenu", preventDefault);
      document.removeEventListener("dragstart", preventDefault);
      document.removeEventListener("keydown", onKeyDown);
      document.removeEventListener("visibilitychange", blurOnHide);
      window.removeEventListener("blur", blurOnBlur);
      window.removeEventListener("focus", unblurOnFocus);
      clearInterval(devToolsInterval);
      document.body.style.filter = "";
    };
  }, [location.pathname]);
}

function AppRoutes() {
  useAntiTheftProtection();
  return (
    <>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/galerie" element={<Gallery />} />
          <Route path="/tarifs" element={<Tarifs />} />
          <Route path="/cartes-cadeaux" element={<GiftCards />} />
          <Route path="/reservation" element={<Reservation />} />
          <Route path="/a-propos" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/mentions-legales" element={<Legal />} />
        </Routes>
      </main>
      <Footer />
      <Toaster />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </div>
  );
}

export default App;
